import { ShippingMethod } from '@/modules/checkout/api';

export function getShippingMethodsByShippingGroup(
  shippingGroup: string,
  shippingMethods: ShippingMethod[]
) {
  return shippingMethods.filter((shippingMethod) =>
    shippingMethod.shippingGroups.includes(shippingGroup)
  );
}
